var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4219 10.1575C15.2684 6.43731 10.9603 4.64458 7.59335 5.31833L7.08978 4.72229L4.87427 6.59692C1.48866 9.47122 2.06349 15.7181 6.16275 20.5565C10.262 25.3949 16.3247 26.9913 19.7009 24.1207L21.9164 22.2461L21.4129 21.65C22.6298 18.4388 21.5659 13.8813 18.4124 10.1611L18.4219 10.1575Z",
    fill: "#EBA25D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6279 8.28614C24.7271 13.1246 25.3056 19.3808 21.9163 22.2457C18.5307 25.12 12.468 23.5236 8.37814 18.6815C4.27888 13.8431 3.70038 7.58681 7.08967 4.72194C10.4753 1.84764 16.538 3.44403 20.6279 8.28614Z",
    fill: "#F0BF6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10049 7.09855C8.97211 7.21381 8.84741 7.33849 8.73947 7.47835C10.6994 6.4201 14.5162 7.48171 17.469 10.9653C20.4217 14.4489 20.8378 18.4016 19.4763 20.16C19.6288 20.0788 19.7776 19.9881 19.906 19.8728C21.6799 18.366 21.4409 14.0619 18.2597 10.2983C15.0784 6.53476 10.8745 5.59172 9.10049 7.09855Z",
    fill: "#DD8C4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4676 10.9657C14.5148 7.48212 10.698 6.42052 8.73808 7.47876C7.37656 9.23718 7.78897 13.1804 10.7454 16.6735C13.6981 20.1571 17.515 21.2187 19.4749 20.1604C20.8364 18.402 20.424 14.4588 17.4676 10.9657Z",
    fill: "#EBA25D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1258 39.1504C26.6406 45.929 26.6388 53.2343 29.6296 57.6944L29.0754 58.7828L33.1087 60.8501C39.2841 64.0082 47.9588 59.4276 52.4885 50.6143C57.0181 41.8011 55.6915 32.0847 49.5055 28.9147L45.4722 26.8474L44.9179 27.9357C39.5597 28.1115 33.6109 32.3719 30.1258 39.1504Z",
    fill: "#EBA25D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.091 37.0819C30.6206 28.2686 39.3071 23.6774 45.4707 26.8461C51.6462 30.0043 52.9728 39.7207 48.4537 48.5457C43.924 57.359 35.2375 61.9502 29.0739 58.7815C22.8985 55.6233 21.5719 45.9069 26.091 37.0819Z",
    fill: "#F0BF6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3022 54.4393C31.5412 54.5643 31.8051 54.6459 32.069 54.7275C29.3632 52.5317 28.605 46.3929 31.8653 40.0272C35.1255 33.6614 40.5755 30.6938 43.9244 31.616C43.7102 31.4476 43.4842 31.2898 43.2452 31.1648C40.0051 29.5102 33.9423 32.433 30.4075 39.2983C26.8844 46.1531 28.0398 52.7835 31.2904 54.4499L31.3022 54.4393Z",
    fill: "#DD8C4A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8526 40.0374C28.5818 46.3914 29.3506 52.5419 32.0563 54.7377C35.417 55.6494 40.867 52.6817 44.1155 46.3265C47.3862 39.9726 46.6175 33.822 43.9222 31.638C40.5616 30.7263 35.1115 33.694 31.8631 40.0492L31.8526 40.0374Z",
    fill: "#EBA25D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.c8072a854dab5c1938d7d57807f4bcaf.svg";
export { ForwardRef as ReactComponent };